import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app/core/services/Common/common.service';
import { DataStoreService } from 'src/app/core/services/Data-Store/data-store.service';
import { EncryptService } from 'src/app/core/services/Encrypt/encrypt.service';
import { HelperService } from 'src/app/core/services/Helper/helper.service';
import { ParamsDataForLog } from 'src/app/interfaces/home-interface';
import { MENU_LOG_PAGE_MAPPING } from 'src/app/model/home.model';
import { AuthService } from 'src/app/sso/service/auth.service';
import { IdleTimerService } from 'src/app/sso/service/idle-timer.service';
import { SsoLoginService } from 'src/app/sso/service/sso-login.service';

@Component({
  selector: 'app-signinloading',
  templateUrl: './signinloading.component.html',
  styleUrls: ['./signinloading.component.scss']
})
export class SigninloadingComponent implements OnInit {

  constructor(private route: Router,
    private activeroute: ActivatedRoute,
    private http: HttpClient, private encryptionService: EncryptService, private formBuilder: FormBuilder,
    private commonService: CommonService,
    private helperService: HelperService,
    private dataStoreService: DataStoreService,
    private router: Router,
    private _helper: HelperService,
    private authService: AuthService,
    private idleTimerService: IdleTimerService,
    public ssologin : SsoLoginService
  ) { }
  authorizationDecryptedResponse: any;
  paramsData: ParamsDataForLog = {
    p: null,
    e: null,
    l: null,
    u: null,
    b: null
  }

  loginResponse: any;
  loading: boolean = false

  hitLogAPIdata() {
    this.loading = true;
    this.commonService.postLogDataCommonService({ url: '/commmon/log-event', data: this.paramsData }).subscribe((res) => {
      this.loading = false;
      if (res) console.log(res);
    }, (err) => {
      this.loading = false;
      console.log(err);
    })
  }

  loginRedirectionCall(roles: any) {
    roles = [...new Set(roles)];
    console.log("print rolees", roles)
    console.log("dialogData")
    // if(this.dialogData.redirectTo === "purohit"){
    //   this.router.navigate(['/home/kendra-mandir/purohit-data']);
    //   this.dataStoreService.updateHeaderComponentStateAfterLoggedIn('updateHeader');
    //   this.closeDialog.emit();
    //   return;
    // }
    if (
      roles.length === 1 &&
      roles.includes('DEVOTEE')
    ) {
      console.log('devotee permisions');
      this.dataStoreService.updateHeaderComponentStateAfterLoggedIn('updateHeader');
      this.router.navigate(['/home']);
    } else if (
      roles.includes('POST_APPROVER') ||
      roles.includes('POST_CREATER') ||
      roles.includes('POST_VIEWER')
    ) {
      this.router.navigate(['/user/mandir-admin/home']);
    } else if (
      roles.includes('CAN_WITHDRAW_MANDIR_FUNDS')
    ) {
      this.router.navigate(['/user/mandir-admin/admin-home']);
    } else if (
      roles.includes('UTSAV_PERM_APPROVER')
    ) {
      this.router.navigate(['/user/utsav-admin/calendar']);
    } else if (
      roles.includes('CAN_VIEW_ORDER_DETAILS')
    ) {
      this.router.navigate(['/user/magazine-admin/magazine-order']);
    } else {
      this.router.navigate(['/home']);
    }
  }






  ngOnInit(): void {
    this.activeroute.queryParams.subscribe(params => {
      const accessCode = params['accessCode'];
    const loginTrigger = params['login'];
    const token = localStorage.getItem('token');


    if (loginTrigger === 'true' && !accessCode && (!token || token=='null' || token=='undefined')) {
      this.ssologin.login();
      return; 
    }

      if (accessCode && (!token || token=='null' || token=='undefined')) {
        // console.log('Access Code found:', accessCode);
        localStorage.setItem('accessCode', accessCode);

        const codeVerifier = localStorage.getItem('sso_code_verifier');

        if (!codeVerifier) {
          this._helper.showError('Something Went Wrong!')
          this.router.navigate(['/home']);
          return;
        }

        // const url = 'https://www.test.satsang.org.in/org/api/v1/auth/token';

        // const headers = new HttpHeaders({
        //   'Content-Type': 'application/json',
        // });

        const payload = {
          code: accessCode,
          codeVerifier: codeVerifier
        };

        this.commonService.postAPICall({ url: '/auth/token', data: payload }).subscribe({
          next: (response: any) => {
            // console.log('Token API Response:', response);
            // console.log('Token API Response:', response);
            this.loginResponse = response.data

            const accessToken = response?.data?.accessToken;
            console.log(response)

            if (accessToken) {
              localStorage.setItem('token', accessToken);
              localStorage.setItem('isLoggedIn', true.toString());
              this._helper.showSuccess(response.msg)
              this.authService.initTimer()
              // start the idle Timer Service to logout on inactivity
              this.idleTimerService.startWatching(() => {
                console.log('Logging out due to inactivity...');
                this.authService.logOut(false);
              });

              // this.authorizationDecryptedResponse = this.encryptionService.getDecodedAccessToken(
              //   accessToken
              // );
              // console.log("auth response========>:", this.authorizationDecryptedResponse)

              localStorage.setItem(
                'username',
                response?.data?.preferred_username
              );
              localStorage.setItem(
                'permissionsObj',
                response?.data?.roles
              );

              this.paramsData = {
                p: MENU_LOG_PAGE_MAPPING.HOME,
                e: null,
                l: null,
                u: this.loginResponse.preferred_username,
                b: null
              };
              this.hitLogAPIdata();
              console.log(this.loginResponse);
              // console.log(this.authorizationDecryptedResponse.roles);


  const redirectAfterLogin = localStorage.getItem('redirectAfterLogin');
    if (redirectAfterLogin && redirectAfterLogin !== 'undefined' && redirectAfterLogin !== 'null') {
      const redirectUrl = redirectAfterLogin; 
      localStorage.removeItem('redirectAfterLogin'); 
      console.log('Redirecting to saved URL:', redirectUrl);
      window.location.href = redirectUrl; 
    } else {
      this.loginRedirectionCall(response?.data?.roles);
    }
              // this.loginRedirectionCall(response?.data?.roles);
              console.log('Access token saved to localStorage');
            } else {
              localStorage.removeItem('accessToken');
              console.warn('No access token found, removed from localStorage');
              this.route.navigateByUrl('/');
              this._helper.showError('Something Went Wrong!')
               localStorage.removeItem('redirectAfterLogin');

            }
          },
          error: (error) => {
            console.error('Token API Error:', error);
            this.route.navigateByUrl('/');
            this._helper.showError(error.msg || 'Error in Login!')
            localStorage.removeItem('redirectAfterLogin');
          }
        });

      } else {
        console.log(' No accessCode found in URL.');
        this.router.navigate(['/home']);
        localStorage.removeItem('redirectAfterLogin');
        // this._helper.showError( 'Error in Login!')
      }
    });

  }

}
